var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRenewEstimator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.998,
    height: 99.998,
    viewBox: "0 0 99.998 99.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10320",
    "data-name": "Group 10320",
    transform: "translate(2660 19801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10320-2",
    "data-name": "Group 10320",
    transform: "translate(0.499 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Renew_-_Flaticon-2",
    "data-name": "Search results for Renew - Flaticon-2",
    transform: "translate(-2660.499 -19487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    transform: "translate(74.998 8.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9922",
    "data-name": "Path 9922",
    d: "M32.583,18.666h-12.5a2.083,2.083,0,0,1,0-4.167H30.5V4.083a2.083,2.083,0,1,1,4.167,0v12.5A2.084,2.084,0,0,1,32.583,18.666Z",
    transform: "translate(-18 -2)",
    fill: "#286c4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9923",
    "data-name": "Path 9923",
    d: "M50,100a50,50,0,1,1,40.22-79.6,2.084,2.084,0,1,1-3.362,2.462A45.756,45.756,0,1,0,95.831,50a41.589,41.589,0,0,0-.4-5.954,2.084,2.084,0,1,1,4.125-.592A45.572,45.572,0,0,1,100,50,50.055,50.055,0,0,1,50,100Z",
    fill: "#286c4d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_54",
    "data-name": "Subtraction 54",
    d: "M46.962,53.522H4.918A3.924,3.924,0,0,1,1,49.6V9.312L2.566,10.82V49.6a2.354,2.354,0,0,0,2.352,2.352H32.39A3.882,3.882,0,0,1,31.6,49.6V38.75l1.854,1.783h-.285V49.6a2.354,2.354,0,0,0,2.352,2.352h6.754V49.017l1.569,1.509v1.428h1.484L46.96,53.52Zm7.526-3.417h0l-1.534-1.535V40.533H44.922l-2.645-2.647V27.545H35.524a2.353,2.353,0,0,0-2.16,1.422l-1.157-1.158a3.905,3.905,0,0,1,3.317-1.832h1.4V3.92a2.355,2.355,0,0,0-2.353-2.353H10.29V5.874L8.722,4.306V2.677l-.814.814L6.8,2.382,8.951.23A.79.79,0,0,1,9.506,0H34.569a3.925,3.925,0,0,1,3.92,3.92V25.977H50.6a3.924,3.924,0,0,1,3.92,3.92V49.6a3.957,3.957,0,0,1-.032.5ZM43.846,27.545V38.965h9.105V29.9A2.355,2.355,0,0,0,50.6,27.545Zm-4.484,21.12a.779.779,0,0,1-.554-.229l-1.084-1.083-1.083,1.083a.784.784,0,0,1-1.109-1.109l1.084-1.083L35.533,45.16a.784.784,0,0,1,1.109-1.109l1.083,1.084.254-.254,1.13,1.087-.275.275,1.084,1.083a.784.784,0,0,1-.554,1.338Zm11.352-3.2h-.869l-1.568-1.569h2.436a.784.784,0,0,1,0,1.569ZM7.622,44.237a.785.785,0,0,1-.784-.785v-.963h-.99a.784.784,0,0,1,0-1.569H7.606a.973.973,0,0,0,0-1.947,2.542,2.542,0,0,1-.768-4.965v-.943a.784.784,0,1,1,1.568,0v.824h.958a.784.784,0,0,1,0,1.569H7.606a.973.973,0,1,0,0,1.947,2.541,2.541,0,0,1,.8,4.954v1.093A.785.785,0,0,1,7.622,44.237Zm14.6-.744H12.952a.784.784,0,1,1,0-1.568h9.266a.784.784,0,1,1,0,1.568Zm6.272-3.136H12.952a.784.784,0,0,1,0-1.568H28.49a.784.784,0,0,1,0,1.568Zm0-3.136H12.952a.784.784,0,0,1,0-1.568H28.383l.887.853A.789.789,0,0,1,28.49,37.22Zm10.02-3.105,0,0-1.641-1.642h.074V30.939a.784.784,0,0,1,1.569,0v1.532H40.04a.784.784,0,1,1,0,1.568H38.509v.076Zm-11.757-.031h-13.8a.784.784,0,1,1,0-1.568H25.122l1.628,1.566Zm23.962-.045H46.083a.784.784,0,0,1,0-1.568h4.631a.784.784,0,0,1,0,1.568ZM18.688,26.327H14.566a1.618,1.618,0,0,1-1.616-1.616v-3.9L14.9,22.688v1.683h1.75l2.031,1.954Zm7.505-4.537,0,0-1.954-1.955V18.017l-4.667-4.384-.788.74L17.4,12.99l1.065-1a1.62,1.62,0,0,1,2.214,0l5,4.7a1.622,1.622,0,0,1,.509,1.178v3.919Zm1.7-4.667a.976.976,0,0,1-.67-.266L19.716,9.8,16.88,12.469,15.5,11.085,19.048,7.75a.977.977,0,0,1,1.338,0l8.177,7.681a.978.978,0,0,1-.67,1.691Z",
    transform: "translate(-2637.759 -19779.762)",
    fill: "#286c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9943",
    "data-name": "Path 9943",
    d: "M16.662,16.56a1.428,1.428,0,0,0-1.08-.41,1.41,1.41,0,0,0-1.023.534A34.874,34.874,0,0,0,7,38.493a35.28,35.28,0,0,0,35.24,35.24,34.881,34.881,0,0,0,21.811-7.558,1.41,1.41,0,0,0,.123-2.1ZM42.24,70.915A32.458,32.458,0,0,1,9.819,38.493a32.056,32.056,0,0,1,6-18.792l7.33,7.33L58.572,62.457l2.461,2.46a32.069,32.069,0,0,1-18.793,6Z",
    transform: "translate(-2652.74 -19789.496)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9944",
    "data-name": "Path 9944",
    d: "M38.494,7a34.881,34.881,0,0,0-21.811,7.558,1.41,1.41,0,0,0-.123,2.1L64.073,64.174a1.41,1.41,0,0,0,1,.413h.083a1.41,1.41,0,0,0,1.023-.534A34.874,34.874,0,0,0,73.734,42.24,35.28,35.28,0,0,0,38.494,7ZM64.918,61.032l-9.509-9.508L27.764,23.879,19.7,15.817a32.069,32.069,0,0,1,18.793-6A32.458,32.458,0,0,1,70.915,42.24,32.056,32.056,0,0,1,64.918,61.032Z",
    transform: "translate(-2648.994 -19793.242)",
    fill: "#00641f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRenewEstimator);
export default __webpack_public_path__ + "static/media/deleteRenewEstimator.f9e3f5b51de600d0f2d5e5e6d2da201f.svg";
export { ForwardRef as ReactComponent };